
/**
 * Get a random number between 0 & n
 */
export const getRandomNumberUpTo = (n = 1) => {
  return Math.round(Math.random() * n)
}
